import React, { PropsWithChildren } from 'react';

/**
 * 右侧块树
 * @description 根据Block树渲染块节点树
 */
export function PicexBlockTree(props: PropsWithChildren<{}>) {
	return <div className=""></div>;
}
